import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BulletinTypeService } from '../bulletin-type/bulletin-type.service';
import { BulletinType } from '../bulletin-type/bulletin-type';

@Injectable({ providedIn: 'root'})
export class BulletinTypeResolver implements Resolve<Observable<BulletinType[]>>{

    constructor(private service: BulletinTypeService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BulletinType[]> {
        return this.service.findAll();
    }
}